export default __webpack_public_path__ + "static/media/arrow_down.c2cbc6e0.svg";